import { StyledInfoBanner, CTALink } from './CatalogTable.styled';

type Props = {
  openCreateCollectionModal: () => void;
};

const CatalogCollectionCTA = ({ openCreateCollectionModal }: Props) => {
  return (
    <StyledInfoBanner>
      With Collections, you can now segment within each catalog and populate your templates with the
      right items for your message and audience.
      <CTALink data-test="cta-link" onClick={openCreateCollectionModal}>
        Create a new collection &rarr;
      </CTALink>
    </StyledInfoBanner>
  );
};

export default CatalogCollectionCTA;
